var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      key: _vm.dialog_popupLabel,
      attrs: { width: "1110" },
      on: { "click:outside": _vm.closeModal },
      model: {
        value: _vm.dialog_popupLabel,
        callback: function($$v) {
          _vm.dialog_popupLabel = $$v
        },
        expression: "dialog_popupLabel"
      }
    },
    [
      _c("v-card", { staticClass: "popup esl-detail" }, [
        _c("div", { staticClass: "popup-titbox" }, [
          _c("h3", { staticClass: "page-title-bar" }, [
            _c("i", { staticClass: "ico ico-label" }),
            _vm._v(_vm._s(_vm.$t("Label Detail")))
          ])
        ]),
        _c("div", { staticClass: "lable-detail-box" }, [
          _c("div", { staticClass: "infoBox leftBox" }, [
            _vm.currentImages.length
              ? _c("div", [
                  _c("div", { staticClass: "img-box" }, [
                    _c("img", {
                      staticClass: "img-label",
                      attrs: { src: "" + _vm.topImage }
                    })
                  ]),
                  _c(
                    "div",
                    { staticClass: "labelInfo" },
                    [
                      _c("v-text-field", {
                        staticClass: "form-input form-status",
                        staticStyle: { width: "110px" },
                        attrs: {
                          value: _vm.labelStatus,
                          label: _vm.$t("Status"),
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: "",
                          readonly: ""
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "form-input ml-4",
                        attrs: {
                          value: _vm.processUpdateTime,
                          label: _vm.$t("Requested Date"),
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: "",
                          readonly: ""
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "form-input ml-2",
                        attrs: {
                          value: _vm.statusUpdateTime,
                          label: _vm.$t("Completed Date"),
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: "",
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "c-pagenation" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-page-prev",
                          attrs: { tile: "", depressed: "" },
                          on: {
                            click: function($event) {
                              return _vm.forwardBtn()
                            }
                          }
                        },
                        [_c("i", { staticClass: "ico-prev" })]
                      ),
                      _vm._l(_vm.imagePageOption, function(value, name) {
                        return _c(
                          "v-btn",
                          {
                            key: name,
                            ref: "labelPageBtn" + name,
                            refInFor: true,
                            staticClass: "btn-page",
                            attrs: {
                              "input-value": value.selected,
                              disabled: value.disabled,
                              tile: "",
                              depressed: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.clickImagePageBtn(name)
                              }
                            }
                          },
                          [_vm._v(_vm._s(name) + " ")]
                        )
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-page-next",
                          attrs: { tile: "", depressed: "" },
                          on: {
                            click: function($event) {
                              return _vm.backwardBtn()
                            }
                          }
                        },
                        [_c("i", { staticClass: "ico-next" })]
                      )
                    ],
                    2
                  )
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "infoBox rightBox" }, [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("v-text-field", {
                  staticClass: "form-input",
                  attrs: {
                    value: _vm.labelId,
                    label: _vm.$t("Label ID"),
                    placeholder: _vm.$t("Input the label ID"),
                    outlined: "",
                    dense: "",
                    "hide-details": "",
                    disabled: "",
                    readonly: ""
                  }
                }),
                _c("v-text-field", {
                  staticClass: "form-input ml-3",
                  attrs: {
                    value: _vm.gateway,
                    label: _vm.$t("Linked Gateway"),
                    outlined: "",
                    dense: "",
                    "hide-details": "",
                    disabled: "",
                    readonly: ""
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex mt-8" },
              [
                _c("v-text-field", {
                  staticClass: "form-input",
                  attrs: {
                    value: _vm.type,
                    label: _vm.$t("Type"),
                    outlined: "",
                    dense: "",
                    "hide-details": "",
                    disabled: "",
                    readonly: ""
                  }
                }),
                _c("v-text-field", {
                  staticClass: "form-input ml-3",
                  attrs: {
                    value: _vm.firmware,
                    label: _vm.$t("Firmware"),
                    outlined: "",
                    dense: "",
                    "hide-details": "",
                    disabled: "",
                    readonly: "",
                    clearable: ""
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "mt-8" }, [
              _c("p", { staticClass: "tit-label" }, [
                _vm._v(_vm._s(_vm.$t("Assign Info")))
              ]),
              _c(
                "div",
                { staticClass: "assignInfo" },
                [
                  _c("div", { staticClass: "assignBox" }, [
                    _vm.btnAssignTxt === _vm.assignType.unassign
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between form-add-btn"
                          },
                          [
                            _c("p", { staticClass: "list_label" }, [
                              _vm._v(_vm._s(_vm.$t("Product ID")))
                            ]),
                            _c(
                              "v-list",
                              {
                                staticClass: "overflow-y-auto",
                                attrs: { dense: "" }
                              },
                              _vm._l(_vm.articleList, function(item, i) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: i,
                                    ref: "article",
                                    refInFor: true,
                                    attrs: { value: item, width: "400" },
                                    on: {
                                      dblclick: function($event) {
                                        return _vm.copyToClipBoard(item)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", {
                                          attrs: { id: item },
                                          domProps: {
                                            textContent: _vm._s(item)
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm.btnAssignTxt === _vm.assignType.assign
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between form-add-btn"
                            },
                            [
                              _c("p", { staticClass: "list_label" }, [
                                _vm._v(_vm._s(_vm.$t("Product ID")))
                              ]),
                              _c(
                                "v-list",
                                {
                                  staticClass: "overflow-y-auto",
                                  attrs: { dense: "" }
                                },
                                [
                                  _vm._l(_vm.assigneArticleList, function(
                                    item,
                                    i
                                  ) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: i,
                                        attrs: { value: item, width: "400" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "form-input",
                                          attrs: {
                                            placeholder: "Input the Product ID",
                                            dense: "",
                                            "hide-details": "",
                                            solo: "",
                                            clearable: ""
                                          },
                                          model: {
                                            value: _vm.assigneArticleList[i],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.assigneArticleList,
                                                i,
                                                $$v
                                              )
                                            },
                                            expression: "assigneArticleList[i]"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                ripple: false,
                                                text: ""
                                              },
                                              on: { click: _vm.clickAddArticle }
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("@/assets/img/ico-add.jpg"),
                                                  alt:
                                                    "Product ID input box add button"
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "customDisabled",
                          rawName: "v-customDisabled",
                          value: _vm.labelUnassignDisabled,
                          expression: "labelUnassignDisabled"
                        }
                      ],
                      staticClass: "btn-assign ml-3",
                      attrs: { text: "" },
                      on: { click: _vm.clickAssign }
                    },
                    [_vm._v(_vm._s(_vm.$t(_vm.btnAssignTxt)) + " ")]
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "mt-8" }, [
              _c("p", { staticClass: "tit-label" }, [
                _vm._v(_vm._s(_vm.$t("Schedule")))
              ]),
              _c(
                "div",
                { staticClass: "schedule-info" },
                [
                  _c(
                    "v-data-table",
                    {
                      staticClass: "tbl-type01",
                      attrs: {
                        headers: _vm.scheduleHeaders,
                        items: _vm.scheduleList,
                        "item-key": "id",
                        page: _vm.page,
                        "hide-default-footer": true,
                        "fixed-header": "",
                        height: "120"
                      },
                      on: {
                        "update:page": function($event) {
                          _vm.page = $event
                        }
                      }
                    },
                    [
                      _c("template", { slot: "no-data" }, [
                        _c("p", [_vm._v(_vm._s(_vm.$t("No data available")))])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ]),
            _vm.accessLevel === "1"
              ? _c(
                  "div",
                  { staticClass: "mt-8" },
                  [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("Individual ESL Image Update")))
                    ]),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("v-file-input", {
                              staticClass: "form-file",
                              attrs: {
                                label: _vm.$t("Image"),
                                placeholder: _vm.$t("Input the image"),
                                type: "file",
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                "prepend-icon": ""
                              },
                              on: {
                                change: _vm.handleChange,
                                keydown: _vm.clearTabindex
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            width: "24",
                                            height: "24",
                                            src: require("@/assets/img/ico-upload-file.gif")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                1414826615
                              ),
                              model: {
                                value: _vm.inputImage,
                                callback: function($$v) {
                                  _vm.inputImage = $$v
                                },
                                expression: "inputImage"
                              }
                            }),
                            _c("v-select", {
                              staticClass: "form-select mt-3",
                              attrs: {
                                label: _vm.$t("Page"),
                                placeholder: _vm.$t("Input the page"),
                                items: ["1", "2", "3", "4", "5", "6", "7"],
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                clearable: ""
                              },
                              on: { keydown: _vm.clearTabindex },
                              model: {
                                value: _vm.inputPage,
                                callback: function($$v) {
                                  _vm.inputPage = $$v
                                },
                                expression: "inputPage"
                              }
                            }),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn btn-update mt-8",
                                attrs: { text: "", icon: "" },
                                on: { click: _vm.saveImage }
                              },
                              [_vm._v(_vm._s(_vm.$t("Image Update")) + " ")]
                            )
                          ],
                          1
                        ),
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c("p", { staticClass: "tit-preview mb-1" }, [
                            _vm._v(_vm._s(_vm.$t("Preview")))
                          ]),
                          _c("div", { staticClass: "preview" }, [
                            _c("img", {
                              staticClass: "img-label",
                              attrs: {
                                src:
                                  "data:image/jpeg;base64," + _vm.encodedImage
                              }
                            })
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _c(
          "div",
          { staticStyle: { padding: "50px" } },
          [
            _c(
              "v-card-actions",
              { staticClass: "d-flex justify-center mt-0" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn",
                    attrs: { text: "", icon: "" },
                    on: { click: _vm.closeModal }
                  },
                  [_vm._v(_vm._s(_vm.$t("Close")))]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }